import React, { useState } from "react";
import { Trash2, Edit } from "lucide-react";
import PropTypes from "prop-types";
import "./TestCard.scss";
import { isRTLText } from "../../../../utils/utils"; // Adjust path if necessary
import DeleteConfirmationDialog from "../../../../components/dialogs/DeleteConfirmationDialog";

/**
 * Card component for displaying test information
 * Updated to support dynamic text direction for the title
 */
const TestCard = ({ test, onSelect, onDelete, onEdit, isDragMode = false }) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const testId = test.id || test._id;
  const testTitle = test.title || `מבחן ${(test.order || 0) + 1}`;
  const questionCount = test.questions?.length || 0;

  const isTitleRTL = isRTLText(testTitle);

  const handleCardClick = () => {
    if (!isDragMode && onSelect) {
      onSelect(testId);
    }
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setIsDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    onDelete(testId);
    setIsDeleteDialogOpen(false);
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    onEdit(testId);
  };

  return (
    <>
      <div
        className={`training-test-card ${isDragMode ? 'training-test-card-draggable' : ''}`}
        onClick={handleCardClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (!isDragMode && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            handleCardClick();
          }
        }}
      >
      <div className="training-card-content">
        {/* Add conditional class for text direction layout */}
        <div className={`training-title-container ${isTitleRTL ? 'rtl-layout' : 'ltr-layout'}`}>
          <h3 className="training-test-title">
            {testTitle}
          </h3>
        </div>
        
        <div className="training-test-questions-count">
          {questionCount} שאלות
          {isDragMode && <span className="training-test-order"> • סדר: {test.order + 1}</span>}
        </div>
      </div>
      
      {!isDragMode && (
        <div className="training-test-card-actions">
          <button 
            className="training-card-action-button training-edit-button"
            onClick={handleEditClick}
            aria-label="ערוך מבחן"
            title="ערוך מבחן"
          >
            <Edit size={16} />
          </button>
          <button 
            className="training-card-action-button training-delete-button"
            onClick={handleDeleteClick}
            aria-label="מחק מבחן"
            title="מחק מבחן"
          >
            <Trash2 size={16} />
          </button>
        </div>
      )}
      </div>
      <DeleteConfirmationDialog 
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
        onConfirm={handleConfirmDelete}
        title={`האם אתה בטוח שברצונך למחוק את המבחן "${testTitle}"?`}
      />
    </>
  );
};

TestCard.propTypes = {
  test: PropTypes.shape({
    id: PropTypes.string,
    _id: PropTypes.string,
    title: PropTypes.string,
    order: PropTypes.number,
    questions: PropTypes.array
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  isDragMode: PropTypes.bool
};

export default TestCard;